import SubHeaders from '@/components/Headers/SubHeaders'
import { useModal } from '@/contexts/modal'
import useTabs from '@/hooks/useTabs'
import { paths } from '@/utils/path'
import { Plus, ScrollText, Users } from 'lucide-react'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { Tabs } from 'vnetwork-ui'
import { CreateEditRegulationModalProps } from './CreateEditModal'
import RegulationAcceptanceList from './regulation-acceptance-list'
import RegulationManagement from './regulation-management'

const RegulationsPage: React.FC = () => {
    const { t } = useTranslation()
    const { setModal } = useModal()

    const handleCreate = () => {
        setModal<CreateEditRegulationModalProps>(
            'RegulationModals/CreateEdit/index',
            {
                regulation: null,
            }
        )
    }

    const { TabComponent, TabProps } = useTabs({
        tabs: [
            {
                label: t('regulations:regulations-management'),
                value: 'management',
                startIcon: <ScrollText className="h-4 w-4" />,
                component: <RegulationManagement />,
            },
            {
                label: t('settings:employees-acceptance-status'),
                value: 'acceptance',
                startIcon: <Users className="h-4 w-4" />,
                component: <RegulationAcceptanceList />,
            },
        ],
    })

    return (
        <div>
            <SubHeaders
                breadcrumbs={[
                    {
                        path: paths.settings,
                        title: t('settings'),
                    },
                    {
                        path: paths.regulations,
                        title: t('regulations:regulations'),
                    },
                ]}
                actions={[
                    {
                        icon: <Plus className="h-4 w-4" />,
                        label: t('regulations:create-regulation'),
                        variant: 'contained',
                        onClick: handleCreate,
                    },
                ]}
            />
            <div className="space-y-2">
                <Tabs {...TabProps} />
                {TabComponent}
            </div>
        </div>
    )
}

export default RegulationsPage
